class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.cartDrawerToggle = document.querySelector('.section-header-cart-drawer-toggle');
        this.cartDrawer = this;

        this.setAttribute('tabindex', '-1');

        if (this.cartDrawerToggle) {
            this.cartDrawerToggle.addEventListener('click', (event) => this.onClick(event));
        }

        // Attach close/overlay listeners via the re-usable method
        this.reAttachInternalListeners();

        document.addEventListener('keyup', (event) => {
            if (event.key === 'Escape') this.close();
        });

        this.previousElement = this.cartDrawerToggle;
    }

    /* Called after every innerHTML replacement to re-attach listeners that
       were bound to specific DOM node references in the constructor.        */
    reAttachInternalListeners() {
        this.cartDrawerClose = this.querySelector('.cart-drawer-close');
        this.cartDrawerOverlay = this.querySelector('.cart-drawer-overlay');
        this.cartDrawerEmptyRedirect = this.querySelector('.cart-drawer-empty-footer');

        if (this.cartDrawerClose) {
            this.cartDrawerClose.addEventListener('click', () => this.close());
            this.cartDrawerClose.addEventListener('keyup', (e) => this.onCloseKeypress(e));
        }
        if (this.cartDrawerOverlay) {
            this.cartDrawerOverlay.addEventListener('click', () => this.close());
        }
        if (this.cartDrawerEmptyRedirect) {
            this.cartDrawerEmptyRedirect.addEventListener('click', () => this.close());
        }
    }

    onClick(event) {
        event.preventDefault();
        this.open();
    }

    onCloseKeypress(event) {
        if (event.key === 'Enter') this.close();
    }

    open() {
        this.previousElement = (document.activeElement || this.cartDrawerToggle);
        this.cartDrawer.setAttribute('aria-hidden', 'false');
        this.cartDrawer.classList.add('active');
        setTimeout(() => {
            const firstLink = this.querySelector('a[href]');
            if (firstLink) firstLink.focus();
        }, 100);
    }

    close() {
        if (this.previousElement && typeof this.previousElement.focus === 'function') {
            this.previousElement.focus();
        }
        this.cartDrawer.setAttribute('aria-hidden', 'true');
        this.cartDrawer.classList.remove('active');
    }
}

customElements.define('cart-drawer', CartDrawer);

/* ------------------------------------------------------------------ */
/*  Fetch fresh cart-drawer HTML and swap innerHTML.                   */
/*  After the swap, re-attach the close/overlay listeners that the     */
/*  CartDrawer constructor bound to the now-destroyed old DOM nodes.   */
/* ------------------------------------------------------------------ */
function updateCartDrawer() {
    const currentDrawer = document.querySelector('cart-drawer');
    if (!currentDrawer) return;

    fetch('/?section_id=cart-drawer')
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('cart-drawer');
            if (!newDrawer || !currentDrawer) return;

            currentDrawer.innerHTML = newDrawer.innerHTML;

            // 1. Re-attach close/overlay listeners destroyed by innerHTML swap
            if (typeof currentDrawer.reAttachInternalListeners === 'function') {
                currentDrawer.reAttachInternalListeners();
            }

            // 2. Theme lazy-loader (IntersectionObserver) isn't re-initialized
            //    for newly injected nodes. The main img already has a real src,
            //    so just mark the figure as loaded to reveal it immediately.
            currentDrawer.querySelectorAll('.lazy-loading-image').forEach(fig => {
                fig.classList.add('lazy-loaded-image');
            });

            // 3. <script> tags injected via innerHTML are NOT executed by browsers.
            //    Clone each one into a real script element so the browser runs it
            //    (needed for the "You may also like" recommendation fetch).
            currentDrawer.querySelectorAll('script').forEach(oldScript => {
                const newScript = document.createElement('script');
                [...oldScript.attributes].forEach(attr =>
                    newScript.setAttribute(attr.name, attr.value)
                );
                newScript.textContent = oldScript.textContent;
                oldScript.parentNode.replaceChild(newScript, oldScript);
            });
        })
        .catch(err => console.error('[cart-drawer] update failed:', err));
}

/* ------------------------------------------------------------------ */
/*  QUANTITY CHANGE                                                     */
/*  The input's `name` attribute holds the cart line item key          */
/*  which the /cart/change.js `id` parameter accepts.                  */
/*  Guard: only handle inputs that are inside the cart-drawer so we    */
/*  don't intercept PDP quantity pickers.                              */
/* ------------------------------------------------------------------ */
document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('product-quantity-picker-input')) return;
    if (!e.target.closest('cart-drawer')) return;   // ignore PDP pickers

    const key      = e.target.name;                 // cart line item key
    const quantity = parseInt(e.target.value, 10);
    if (!key || isNaN(quantity)) return;

    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(r => r.json())
    .then(() => updateCartDrawer())
    .catch(err => console.error('[cart-drawer] qty change failed:', err));
});

/* ------------------------------------------------------------------ */
/*  REMOVE ITEM                                                         */
/*  Use e.target.closest() so clicks on the SVG icon inside the        */
/*  anchor are still caught. Parse the line number from href.          */
/* ------------------------------------------------------------------ */
document.addEventListener('click', function (e) {
    const removeBtn = e.target.closest('.cart-product-remove');
    if (!removeBtn) return;

    e.preventDefault();

    const href      = removeBtn.getAttribute('href') || '';
    const lineMatch = href.match(/line=(\d+)/);
    const line      = lineMatch ? parseInt(lineMatch[1], 10) : null;
    if (!line) return;

    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
    })
    .then(r => r.json())
    .then(() => updateCartDrawer())
    .catch(err => console.error('[cart-drawer] remove failed:', err));
});
